import Layout from 'components/Layout';
import NotFound from 'components/NotFound';
import ServerError from 'components/ServerError';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

interface Props {
  statusCode?: number;
}

export default function Error({ statusCode }: Props): JSX.Element {
  const { t } = useTranslation();

  function errorComponent(): ReactNode {
    switch (statusCode) {
      case 404:
        return <NotFound />;
      case 500:
        return <ServerError />;
      default:
        // Fill this in later
        return undefined;
    }
  }

  return (
    <div>
      <Layout title={t(`main.meta.pageTitle`)} description={t(`main.meta.metaDescription`)}>
        {errorComponent()}
      </Layout>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ res }) => {
  const { statusCode } = res;

  return { props: { statusCode } };
};
